import { AddressDetailModel } from 'app/shared/models/address/address.model';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { store } from 'app/shared/store/store';

class Mapper {
  public mapProductSearchRequestModel(address: AddressDetailModel): ProductSearchRequestModel {
    if (!address) {
      return null;
    }
    const productSearchRequestModel = new ProductSearchRequestModel();
    productSearchRequestModel.floorNumber = address.floor ? address.floor : null;
    productSearchRequestModel.unitNumber = address.unitNumber ? address.unitNumber : null;
    productSearchRequestModel.streetNumber = address.streetNumber ? address.streetNumber : null;
    productSearchRequestModel.streetName = address.streetName ? address.streetName : null;
    productSearchRequestModel.streetType = address.streetType ? address.streetType : null;
    productSearchRequestModel.streetTypeSuffix = address.streetTypeSuffix ? address.streetTypeSuffix : null;
    productSearchRequestModel.suburb = address.suburb ? address.suburb : null;
    productSearchRequestModel.state = address.state;
    productSearchRequestModel.postcode = address.postcode;
    productSearchRequestModel.latitude = address.latitude;
    productSearchRequestModel.longitude = address.longitude;
    productSearchRequestModel.deliveryPointId = address.deliveryPointIdentifier;
    productSearchRequestModel.webCampaignId = store.get(StoreKeys.webId) ? store.get(StoreKeys.webId) : null;
    return productSearchRequestModel;
  }
}

export const mapper = new Mapper();
